import { FilterEffects } from './filter.effects';
import { CurrentFilterEffects } from './current-filter.effects';

export const filterEffects: any[] = [FilterEffects];
export const currentFilterEffects: any[] = [CurrentFilterEffects];

export * from './filter.effects';
export * from './current-filter.effects';
